import TermConditionView from "./TermConditionView";

export default function TermConditionController(props){

    return(
        <TermConditionView 
            open={props.open}
            onClose={props.onClose}
        />
    );
}